import React from "react"
import { withStyles } from "@ridecell/web-components-material"

import StripeForm from "./Stripe/StripeForm"
import styles from "./styles"
import useGlobalContext from "../../../utils/customHooks/useGlobalContext"
import AxeptaHostedPage from "./Axepta/AxeptaHostedPage"

// Show Payment method according the Payment Provider config.

const AddPaymentMethod = ({
  customerId,
  returnUrl,
  onClose,
  headerText,
  handleNext,
  openProfilePanel,
  headerNeeded,
}) => {
  const {
    state: { tenantSettings },
  } = useGlobalContext()

  return (
    <React.Fragment>
      {tenantSettings.paymentProvider === "stripe" && (
        <StripeForm
          customerId={customerId}
          handleNext={handleNext}
          headerText={headerText}
          onClose={onClose}
          returnUrl={returnUrl}
        />
      )}
      {tenantSettings.paymentProvider === "axepta" && (
        <AxeptaHostedPage
          handleNext={handleNext}
          customerId={customerId}
          onClose={onClose}
          headerNeeded={headerNeeded}
        />
      )}
    </React.Fragment>
  )
}

export default withStyles(styles)(AddPaymentMethod)
